<div class="options-library-set">
  @if (optionSets().length <= 0) {
    <span class="fs__sm fw__600">No Options Sets created yet.</span>
  } @else {
    <div class="options-library-set__search">
      <eiq-search-input placeholder="Type to filter by question title" [formControl]="filterCtrl"></eiq-search-input>
    </div>

    @for (optionSet of optionSetsFiltered(); track optionSet.name) {
      <empathy-options-library-set-card
        [optionSet]="optionSet"
        [checked]="optionSet.id === selectedSet$()"
        (delete)="onDeleteOptionSet(optionSet.id)"
        (duplicate)="onDuplicateOptionSet(optionSet.id)"
        (edit)="onEditOptionSet(optionSet.id)"
        (selected)="onSelectSet($event, optionSet.id)"
      ></empathy-options-library-set-card>
    }
  }
</div>
